/**
 * レベルの経過時間計測。モーダル・広告中の pause 除外と、クリア確定時の
 * freeze（以降は時計が進んでも値が変わらない）を持つ。Phaser 非依存。
 */
export class LevelTimer {
  private readonly startedAt: number;
  private pausedAccumulatedMs = 0;
  private pausedAt: number | null = null;
  private frozenElapsedMs: number | null = null;

  constructor(private readonly now: () => number = () => performance.now()) {
    this.startedAt = this.now();
  }

  pause(): void {
    if (this.pausedAt === null) {
      this.pausedAt = this.now();
    }
  }

  resume(): void {
    if (this.pausedAt === null) {
      return;
    }
    this.pausedAccumulatedMs += this.now() - this.pausedAt;
    this.pausedAt = null;
  }

  /** クリア確定時に呼ぶ。以降 elapsedMs はこの瞬間の値で固定される。 */
  freeze(): void {
    if (this.frozenElapsedMs === null) {
      this.frozenElapsedMs = this.runningElapsedMs();
    }
  }

  elapsedMs(): number {
    return this.frozenElapsedMs ?? this.runningElapsedMs();
  }

  private runningElapsedMs(): number {
    const now = this.now();
    const activePause = this.pausedAt === null ? 0 : now - this.pausedAt;
    return Math.max(0, now - this.startedAt - this.pausedAccumulatedMs - activePause);
  }
}
